//---- components ---------
//---- mixins -------------
//---- services -----------
import AuthService from '../services/auth.service.js';
//---- other --------------
import store from '@/app/store/index.js'
//---- 3rd-parties --------

export const initialState = {
  loginStatusKnown: false,
  user: undefined,
  // withUserSession is not currently in use, delete it if we don't need it
  withUserSession: false, // this indicates if the user has a usersession. This is not the case for solo during the first sync.
  relayState: '',
  error: null
}
export const auth = {
  namespaced: true,
  state: { ...initialState },

  actions: {

    login({ commit }, {user, type}) {
      commit('loginUndefined');
      commit('reset', null, { root: true });

      return AuthService.login(user, type).then(
        responseData => {
          if (responseData.isSolo != null && typeof responseData.isSolo != "undefined")
          store.dispatch("kmOffline/updateIsSolo", responseData.isSolo, { root: true });

          if (responseData.isSolo) {
            store.dispatch("kmOffline/updateStatus", responseData.soloStatus, { root: true });
            if (responseData.soloStatus?.onlineAuthenticated) {
              // set a timeout, if not, we get kicked out to the login page again
              AuthService.setSessionTimeout(15*60*1000); // set a 15 min timeout
              store.dispatch("kmOffline/onlineAuthenticated", true, { root: true });
              if (responseData.soloStatus.returningUser) {
                commit('onlineAuthenticated', responseData.soloStatus.returningUser);
                return Promise.resolve(responseData);
              }
            }
          }
          
          if (responseData?.header?.user?.userId) {
            commit('loginSuccess', responseData.header.user.userId);
            return Promise.resolve(responseData);
          }
          else {
            commit('loginFailure', responseData);
            return Promise.reject(responseData);
          }
        },
        errorMessage => {
          return store.dispatch("kmOffline/updateIsSolo", errorMessage.response.data.isSolo, { root: true }).then(() => {
              commit('loginFailure', errorMessage);
              return Promise.reject(errorMessage);
          });
        }
      );
    }, // login

    async checkLogin({ dispatch }) {
      return await dispatch("login", {user: null, type: "check"});
    }, // checkLogin

    logout({ commit }) {
      commit('logout');
      commit("clearAllNotification", null, { root: true });
    },

    setRelayState({ commit }, fullPath) {
      commit('setRelayState', fullPath)
    }
  }, // end actions

  mutations: {

    loginUndefined(state) {
      state.user = undefined;
      state.error = null;
      state.withUserSession = false;
      state.loginStatusKnown = false;
    },

    loginSuccess(state, user) {
      state.user = user;
      state.error = null;
      state.withUserSession = true;
      state.loginStatusKnown = true;
    },

    onlineAuthenticated(state, user) {
      state.user = user;
      state.error = null;
      state.withUserSession = false;
      state.loginStatusKnown = true;
    },

    loginFailure(state, errorObject) {

      state.error = errorObject?.response?.data || errorObject;
      // also update the connection status if present
      if (typeof errorObject == "object" && errorObject?.response?.data?.hServiceConnectivity)
        store.dispatch("kmOffline/updateConnectedState", {
                browserConnectivity: navigator.onLine,
                backendInternetConnectivity: errorObject?.response?.data?.internetConnectivity,
                hServiceConnectivity: errorObject?.response?.data?.hServiceConnectivity
        }, { root: true });
      state.user = null;
      state.withUserSession = false;
      state.loginStatusKnown = true;
    },

    logout(state) {
      state.user = null;
      state.error = null;
      state.withUserSession = false;
      state.loginStatusKnown = true;
    },

    onTimeout(state) {
      state.user = null;
      state.error = { key: "timedOut" };
      state.withUserSession = false;
      state.loginStatusKnown = true;
    },

    setRelayState(state, fullPath) {
      state.relayState = fullPath
    }

  },  // end mutations

  getters: {
    loggedIn(state) {
      return !!state.user
    },

    username(state) {
      return state.user;
    },

    isLoginStatusKnown(state) {
      return state.loginStatusKnown;
    },

    hasUserSession(state) {
      return state.withUserSession;
    },

    // this returns an object that either contains a key or a localizedMessage
    loginError(state) {
      return state.error;
    },

    relayState(state) {
      return state.relayState;
    }
  } // end getters
};